import { render, staticRenderFns } from "./AppSettingsAmaOption.vue?vue&type=template&id=0274f3de&scoped=true&"
import script from "./AppSettingsAmaOption.vue?vue&type=script&lang=js&"
export * from "./AppSettingsAmaOption.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsAmaOption.vue?vue&type=style&index=0&id=0274f3de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0274f3de",
  null
  
)

export default component.exports